export default __webpack_public_path__ + "static/flop-pm-presentation-6deec33281fe4fa8e4b401a8bd03c5f4.png";